import React from 'react';
import WidgetItem from '../../widget-grid/jsx/WidgetItem';
import styles from '../css/functional.module.scss';

export default function SocialFeedLoadingState({ title }) {
    return (
        <WidgetItem title={title} scrollable>
            <div className={`social-feed-loading ${styles.socialFeedLoading}`}>
                <div className={`social-feed-loading__label ${styles.socialFeedLoadingLabel}`}>Loading...</div>
                <div className={`social-feed-loading__card ${styles.socialFeedLoadingCard}`}>
                    <div className="social-feed-loading__shadow" />
                </div>
                <div className={`social-feed-loading__card ${styles.socialFeedLoadingCard}`}>
                    <div className="social-feed-loading__shadow" />
                </div>
            </div>
        </WidgetItem>
    );
}
